// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3bhbA","title":"Info_title__lgXD6","links":"Info_links__2SoNQ","link":"Info_link__1s-yS","logo":"Info_logo__3qK_J"};